import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { MantineProvider } from '@mantine/core';
import { initSentry } from './sentry.config';
import ReactGA from "react-ga4";

/* =================================================================
   TOGGLE: Comment/Uncomment imports to switch between apps
   ================================================================= */

// MAIN APP imports (Comment these for Cricket App)
// import App from './App';
// import { store } from "./store/index";

// CRICKET APP imports (Uncomment these for Cricket App)
import CricketApp from './CricketApp';
import { cricketStore } from "./store/cricketStore";

// Initialize Sentry
initSentry();
ReactGA.initialize("GTM-W4FQL7LH");

/* =================================================================
   TOGGLE: Comment/Uncomment ONE render section below
   Also update index.html root div accordingly
   ================================================================= */

/* -----------------------------------------------------------------
   MAIN APP (Default) - With Authentication
   Root element: <div id="root"></div>
   ----------------------------------------------------------------- */
// const rootElement = document.getElementById("root");
// if (rootElement) {
//   ReactDOM.createRoot(rootElement).render(
//     <MantineProvider withGlobalClasses>
//       <BrowserRouter>
//         <Provider store={store}>
//           <App />
//         </Provider>
//       </BrowserRouter>
//     </MantineProvider>
//   );
// }

/* -----------------------------------------------------------------
   CRICKET APP - No Authentication Required
   Root element: <div id="cricket-root"></div>
   Default route: /cricket
   ----------------------------------------------------------------- */
const cricketRootElement = document.getElementById("cricket-root");
if (cricketRootElement) {
  ReactDOM.createRoot(cricketRootElement).render(
    <MantineProvider withGlobalClasses>
      <BrowserRouter>
        <Provider store={cricketStore}>
          <CricketApp />
        </Provider>
      </BrowserRouter>
    </MantineProvider>
  );
}
